module.exports = __webpack_public_path__ + "static/building-apps-video-fdd170d2c91144154884d0a6ea362587.mp4";